import React, {useEffect, useState} from "react"
import Tooltip from "rc-tooltip"
import { Link } from "gatsby"

import About01Image from "../../images/about01.svg"
import questionImg from "../../images/new-pricing/question.svg"

import p1Img from "../../images/new-pricing/p1.png"
import p2Img from "../../images/new-pricing/p2.svg"
import p3Img from "../../images/new-pricing/p3.svg"

import {
  GET_PAID_PLAN,
  PAY_BILLS_PLAN,
  COMBINED_PLAN,
} from "../../data/pricing-features"
import queryString from "query-string";
import ReactGA from "react-ga";
const CustomToolTip = props => {
  const tooltipStyle = {
    height: "auto",
    width: props.width,
    textAlign: "center",
    verticalAlign: "middle",
  }
  return (
    <Tooltip
      overlayStyle={tooltipStyle}
      placement="top"
      overlay={props.tooltipText}
      trigger={["hover"]}
      arrowContent={<div className="rc-tooltip-arrow-inner" />}
    >
      {props.children}
    </Tooltip>
  )
}

export default function Plans({ onlyQbo = false, location = {}, nsip = false, registrationDetails = null, refToken, page, disabledSoloPlanBtn }) {
  const [referralToken, setReferralToken] = useState("")
  const [isSpecialOfferCode, setSpecialOfferCode] = useState(false);

  const { state = {} } = location;
  useEffect(() => {
    const urlState = queryString.parse(location.search)
    if(urlState.ref_token){
      setReferralToken(urlState.ref_token);
    }
  }, [])

  useEffect(() => {
    if(refToken){
      setReferralToken(refToken)
    }
  }, [refToken])

  const pricingBtnClick = (planName, btn) => {
    ReactGA.event({
      category: `${page}_${planName} plan ${btn}_Button`,
      action: `${page}_${planName} plan ${btn}_Button Clicked`
    });
  }

  return (
    <div className="plans mx-auto flex">
      <div className="card1" style={{height: "920px"}}>
        <div className="title font-semibold" style={{textIndent: "-9999px", paddingTop: '59px', borderTopRightRadius: 0}}/>
        <div className="content">
          <div className="flex flex-row ml-2" >
            <img
              src={About01Image}
              alt="luca"
              className="pricing-icon"
              data-parallax='{"x" : -50}'
            />
            <div className="ml-10 text-left">
              <h3 className="text-brand leading-7 font-medium uppercase text-lg">
                Combined plan
              </h3>
              <div className="flex justify-center text-gray-14 ">
                Get paid + Pay Bills
              </div>
              <h2 className="text-30 font-bold text-mind mt-0 mb-0">
                $79
                <span className="text-xl">
                    /mo
                    <span className="uppercase text-sm text-gray-14 font-medium ml-1">
                      AUD
                    </span>
                  </span>
              </h2>
              {/*<span className="flex t2 text-gray-14 mt-1">*/}
              {/*  Best for sole traders*/}
              {/*  <CustomToolTip*/}
              {/*    height="131px"*/}
              {/*    width="211px"*/}
              {/*    tooltipText={*/}
              {/*      <span>*/}
              {/*        If you’re a sole trader and looking to purely send*/}
              {/*        e-invoices & manage your bills this is the plan for you!*/}
              {/*        No accounting software needed.*/}
              {/*      </span>*/}
              {/*    }*/}
              {/*  >*/}
              {/*    <img*/}
              {/*      src={questionImg}*/}
              {/*      className="ml-1"*/}
              {/*      alt="luca"*/}
              {/*      data-parallax='{"x" : -50}'*/}
              {/*    />*/}
              {/*  </CustomToolTip>*/}
              {/*</span>*/}
            </div>
          </div>
          <Link
            className="free-btn-banner text-white float-right hidden sm:flex items-center justify-content-center"
            onClick={() => pricingBtnClick("combined", "start now")}
            to={`/sign-up/?plan=combined${referralToken && `&ref_token=${referralToken}`}`}
            state={{ isTrial: true, plan: "combined", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page }}
          >
            30 days free trial
          </Link>
          <div className="line mb-12" />
          <ul className="leading-6 text-left middle-content__list pl-4 sm:pl-0 combined-plan" style={{height: "541px", marginRight: "0 !important", maxWidth: "333px", width: "333px"}}>
            {COMBINED_PLAN.map(data =>
                !data.trialText &&
                <li className={`${data.icon}`}>
                  <div>{data.content}</div>
                  {data.tooltip && (
                      <CustomToolTip
                          height={data.tooltipHeight}
                          width={data.tooltipWidth}
                          tooltipText={data.tooltipText}
                      >
                        <img
                            src={questionImg}
                            className="ml-1"
                            alt="luca"
                            data-parallax='{"x" : -50}'
                        />
                      </CustomToolTip>
                  )}
                </li>
            )}
          </ul>
          <div className="bottom-content">
            <Link
              onClick={() => pricingBtnClick("combined", "start now")}
              to={`/sign-up/?plan=combined${referralToken && `&ref_token=${referralToken}`}`}
              state={{ isTrial: true, plan: "combined", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page }}
            >
              <button
                disabled={disabledSoloPlanBtn}
                className={`bg-mind rounded leading-7 text-white capitalize w-full ${!disabledSoloPlanBtn && "hover:bg-mint2"} py-1`}
              >
                Start Now
              </button>
            </Link>
            <div className="side-line mt-3 mx-auto">
              30 days free
            </div>
            {/*<Link*/}
            {/*    to={`/sign-up/${referralToken && `?ref_token=${referralToken}`}`}*/}
            {/*  state={{ isTrial: true, plan: "solo", price: 0, referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails}}*/}
            {/*>*/}
            {/*  <button className="bg-white border-brand rounded leading-7 mt-3 capitalize w-full hover:bg-brand hover:text-white">*/}
            {/*    Free Trial*/}
            {/*  </button>*/}
            {/*</Link>*/}
          </div>
        </div>
      </div>
      <div className="card2">
        <div className="s1">
          <div className="title">
            <div className="mobile-dev font-semibold">
              <div className="flex justify-between items-center t2">
                {!onlyQbo && (
                  <div className=" w-10">
                    <img src={p1Img} alt="accounting software logo" />
                  </div>
                )}
                {!onlyQbo && (
                  <div className="">
                    <img src={p2Img} alt="accounting software logo" />
                  </div>
                )}

                <div className="">
                  <img src={p3Img} alt="accounting software logo" />
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <div className="section1">
              <div className="text-center top-header2" style={{marginBottom: "38px"}}>
                <h3 className="text-brand leading-7 font-medium  mt-1 uppercase text-lg">
                  GET PAID
                </h3>
                <h2 className="text-30 font-bold text-mind mt-0 mb-0">
                  $49
                  <span className="text-xl">
                  /mo
                  <span className="uppercase text-sm text-gray-14 font-medium ml-1">
                    AUD
                  </span>
                </span>
                </h2>
              {/*  <h2 className="text-30 tracking-widest font-bold text-mind mt-0 mb-0">*/}
              {/*    FREE*/}
              {/*  </h2>*/}
              {/*  <div className="flex justify-center text-gray-14">*/}
              {/*    Best for new starter*/}
              {/*    <CustomToolTip*/}
              {/*      height="146px"*/}
              {/*      width="211px"*/}
              {/*      tooltipText={*/}
              {/*        <span>*/}
              {/*          Just starting out and looking for an e-invoicing*/}
              {/*          solution? OR for an Accounting software solution?*/}
              {/*          <br />*/}
              {/*          <br /> Then this plan is for you!*/}
              {/*        </span>*/}
              {/*      }*/}
              {/*    >*/}
              {/*      <img*/}
              {/*        src={questionImg}*/}
              {/*        className="ml-1"*/}
              {/*        alt="luca"*/}
              {/*        data-parallax='{"x" : -50}'*/}
              {/*      />*/}
              {/*    </CustomToolTip>*/}
              {/*  </div>*/}
              </div>
              <Link
                className="free-btn-banner text-white float-right hidden sm:flex items-center justify-content-center"
                onClick={() => pricingBtnClick("get_paid", "start now")}
                to={`/sign-up/?plan=get_paid${referralToken && `&ref_token=${referralToken}`}`}
                state={{ isTrial: true, plan: "get_paid", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page }}
              >
                30 days free trial
              </Link>
              <div className="right-border">
                <div className="line mb-12" />
                <ul className="leading-6 text-left middle-content__list pl-6 sm:pl-0 combined-plan" style={{height: "541px"}}>
                  {
                    GET_PAID_PLAN.map(data => (
                    <li className={`${data.icon}`}>
                      <div>{data.content}</div>
                      {data.tooltip && (
                        <CustomToolTip
                          height={data.tooltipHeight}
                          width={data.tooltipWidth}
                          tooltipText={data.tooltipText}
                        >
                          <img
                            src={questionImg}
                            className="ml-1"
                            alt="luca"
                            data-parallax='{"x" : -50}'
                          />
                        </CustomToolTip>
                      )}
                    </li>
                  ))}
                </ul>
                <div className="bottom-content">
                  <Link
                      onClick={() => pricingBtnClick("get_paid", "start now")}
                      to={`/sign-up/?plan=get_paid${referralToken && `&ref_token=${referralToken}`}`}
                      state={{ isTrial: true, plan: "get_paid", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, page: page}}
                  >
                    <button className="bg-mind rounded leading-7 text-white capitalize w-full hover:bg-mint2 py-1">
                      Start Now
                    </button>
                  </Link>
                  <div className="side-line mt-3 mx-auto">
                    30 days free
                  </div>
                  {/*<Link*/}
                  {/*  to={`/sign-up/${referralToken && `?ref_token=${referralToken}`}`}*/}
                  {/*  state={{ isTrial: true, plan: "starter", price: 0, referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails }}*/}
                  {/*>*/}
                  {/*  <button className="bg-white border-brand rounded leading-7 mt-3 capitalize w-full hover:bg-brand hover:text-white">*/}
                  {/*    Yes it's Free*/}
                  {/*  </button>*/}
                  {/*</Link>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="s2">
          <div className="title">
            {/*<div className="flex justify-start items-center t2">*/}
            {/*  {!onlyQbo && (*/}
            {/*    <div className="mr-10 w-10">*/}
            {/*      <img src={p1Img} alt="accounting software logo" />*/}
            {/*    </div>*/}
            {/*  )}*/}
            {/*  {!onlyQbo && (*/}
            {/*    <div className="mr-10">*/}
            {/*      <img src={p2Img} alt="accounting software logo" />*/}
            {/*    </div>*/}
            {/*  )}*/}

            {/*  <div className="mr-10">*/}
            {/*    <img src={p3Img} alt="accounting software logo" />*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<div className="mobile-dev font-semibold">Accounting Software Supported</div>*/}
          </div>
          <div className="content">
            <div className="section2">
              <div className="text-center top-header2" style={{marginBottom: "42px"}}>
                <h3 className="text-brand leading-7 font-medium uppercase text-lg">
                  Pay Bills
                </h3>
                <h2 className="text-30 font-bold text-mind mt-0 mb-0">
                  $39
                  <span className="text-xl">
                  /mo
                  <span className="uppercase text-sm text-gray-14 font-medium ml-1">
                    AUD
                  </span>
                </span>
                </h2>
                {/*<div className="flex justify-center text-gray-14">*/}
                {/*  Best for growing or scaling businesses*/}
                {/*  <CustomToolTip*/}
                {/*    height="222px"*/}
                {/*    width="211px"*/}
                {/*    tooltipText={*/}
                {/*      <span>*/}
                {/*        This plan is suitable for a small-medium business who is*/}
                {/*        thriving and needs the flexibility sending & receiving*/}
                {/*        unlimited e-invoices.*/}
                {/*        <br />*/}
                {/*        <br />*/}
                {/*        Plus, the additional user comes in handy when you start*/}
                {/*        using an Accountant/Bookkeeper or need extra help with*/}
                {/*        your accounts in your business.*/}
                {/*      </span>*/}
                {/*    }*/}
                {/*  >*/}
                {/*    <img*/}
                {/*      src={questionImg}*/}
                {/*      className="ml-1"*/}
                {/*      alt="luca"*/}
                {/*      data-parallax='{"x" : -50}'*/}
                {/*    />*/}
                {/*  </CustomToolTip>*/}
                {/*</div>*/}
              </div>
              <Link
                className="free-btn-banner text-white float-right hidden sm:flex items-center justify-content-center"
                onClick={() => pricingBtnClick("pay_bills", "Start now")}
                to={`/sign-up/?plan=pay_bills${referralToken && `&ref_token=${referralToken}`}`}
                state={{ isTrial: true, plan: "pay_bills", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page }}
              >
                30 days free trial
              </Link>
              <div className="line mb-12" />
              <ul className="leading-6 text-left middle-content__list pl-6 sm:pl-0" style={{height: "541px"}}>
                {PAY_BILLS_PLAN.map(data =>
                    !data.trialText &&
                    <li className={`${data.icon}`}>
                      <div className={`flex w-full`}>
                        <div>{data.content}</div>
                        {/*{*/}
                        {/*  data.comingSoonImg &&*/}
                        {/*    <div className={`w-2/6 coming-soon-img ml-2 mt-`}>*/}
                        {/*      Coming Soon*/}
                        {/*    </div>*/}
                        {/*}*/}
                      </div>
                      {data.tooltip && (
                          <CustomToolTip
                              height={data.tooltipHeight}
                              width={data.tooltipWidth}
                              tooltipText={data.tooltipText}
                          >
                            <img
                                src={questionImg}
                                className="ml-1"
                                alt="luca"
                                data-parallax='{"x" : -50}'
                            />
                          </CustomToolTip>
                      )}
                    </li>
                )}
              </ul>
              <div className="bottom-content">
                <Link
                  onClick={() => pricingBtnClick("pay_bills", "Start now")}
                  to={`/sign-up/?plan=pay_bills${referralToken && `&ref_token=${referralToken}`}`}
                  state={{ isTrial: true, plan: "pay_bills", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page}}
                >
                  <button className="bg-mind rounded leading-7 text-white capitalize w-full  hover:bg-mint2 py-1">
                    Start Now
                  </button>
                </Link>
                {/*<Link*/}
                {/*  to={`/sign-up/${referralToken && `?ref_token=${referralToken}`}`}*/}
                {/*  state={{ isTrial: true, plan: "standard", price: 0, referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails }}*/}
                {/*>*/}
                {/*  <button className="bg-white border-brand rounded leading-7 mt-3 capitalize w-full hover:bg-brand hover:text-white">*/}
                {/*    Free Trial*/}
                {/*  </button>*/}
                {/*</Link>*/}
                <div className="side-line mt-3 mx-auto">
                  30 days free
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
